import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    // 사용자/관리자 메뉴 전환 진행 여부 (전환 오버레이 표시용)
    isMenuSwitching: false,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        /**
         * 메뉴 모드 전환 시작 (전환 오버레이 표시)
         */
        startMenuSwitch: (state) => {
            state.isMenuSwitching = true;
        },

        /**
         * 메뉴 모드 전환 종료 (전환 오버레이 숨김)
         */
        endMenuSwitch: (state) => {
            state.isMenuSwitching = false;
        },
    },
});

export const {
    startMenuSwitch,
    endMenuSwitch,
} = uiSlice.actions;

export default uiSlice.reducer;
